import AAmountInfo from './a-amount-info';

export default AAmountInfo;